import { render, staticRenderFns } from "./LBS_Shelf.vue?vue&type=template&id=67b14620&"
import script from "./LBS_Shelf.vue?vue&type=script&lang=js&"
export * from "./LBS_Shelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b14620')) {
      api.createRecord('67b14620', component.options)
    } else {
      api.reload('67b14620', component.options)
    }
    module.hot.accept("./LBS_Shelf.vue?vue&type=template&id=67b14620&", function () {
      api.rerender('67b14620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Multifunction/LBS_Shelf.vue"
export default component.exports